import React from 'react';
import {useState } from 'react';
import {useSelector,useDispatch} from 'react-redux'
import axios from 'axios'
import {Link} from 'react-router-dom'


function Ocomitet(props){
    const data = useSelector(state => state.nab)
    const dispatch = useDispatch()
    const [load,setLoad] = useState(false)


 

    function getData (){
      axios.get(`/?id=WIrbis&action=Conference/GetComitets&sid=${props.sid}`).then((resp) => {
        dispatch ({type:'TABLE_LOAD_NAB', payload4: resp.data})
        setLoad(true)
        console.log(resp.data)  
 
    })
    }
    
         
         
let a = null
    
   

    
  
  if (load === false) 
  {
    return <p onLoad={getData()}>Loading...</p>
}
  else{
    return(
        <div href="/organization">
        
                   
                            {
                                    data.map((member) =>{
                                     
                                     if (member.part != a && member.com == 'Организационный комитет'){
                                        
                                        a= member.part
                                         return(
                                            <div className="section" >
           
                                                <div className="heading">
                                                    <h3>{member.part}</h3>

                                                    </div>
                                                    <div className='heading-info'>
                                                        {
                                                            data.map((m) =>{
                                                                
                                                                if(m.part == a && m.com == 'Организационный комитет' ){
                                                                    return(
                                                                        <span className="description general" key={m.id}><Link to='/speaker' onClick={(e) => dispatch({type:'TABLE_LOAD_SPEAKER', payload6: member.id})}>{m.title}</Link></span>
                                                                    )
                                                                }
                                                            })
                                                        }
                                                    </div>
                                                    </div>
                                                                    )
                                     }else{
                                        a = member.part
                                     }  
                                    })
                                 }
                            
                     
               
               
            


    </div>
)}}



export default Ocomitet